/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { CustomerState, customerAdapter } from 'components/pages/console/store/CustomerSlice';
import Customer from 'gql/Customer';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';

const selectSelf = (state: RootState): CustomerState => {
  return state.customer;
};

const selectCustomer = createSelector(selectSelf, (state: CustomerState): Customer | undefined => {
  return state.customer ? state.customer : undefined;
});

const selectFetchCustomerState = createSelector(selectSelf, (state: CustomerState): ActionStatus => {
  return state.fetchCustomerState.status;
});

const selectFetchCustomersState = createSelector(selectSelf, (state: CustomerState): ActionStatus => {
  return state.fetchCustomersState.status;
});

const selectCustomers = createSelector(selectSelf, (state: CustomerState): Customer[] => {
  return customerAdapter.getSelectors().selectAll(state.customers);
});

const CustomerSelectors = {
  selectCustomer,
  selectFetchCustomerState,
  selectFetchCustomersState,
  selectCustomers,
};

export default CustomerSelectors;
